import { SceneryActionType } from '../model/scenery-action-type';
import { EDeviceCategory } from './device-categories';

export const SCENERY_ACTION_TYPES: SceneryActionType[] = [
    { Id: 1, Name: 'EXECUTE_COMMAND', Target: [EDeviceCategory.Automation, EDeviceCategory.Virtual] },
    { Id: 2, Name: 'WAIT', Target: [EDeviceCategory.Automation, EDeviceCategory.Virtual] },
    { Id: 3, Name: 'APPLY_CONFIGURATION', Target: [EDeviceCategory.Automation] },
];

export const WAIT_TIME_UNITS = [
    {Label: 'MS', Scale: 1},
    {Label: 'S', Scale: 1000},
    {Label: 'M', Scale: 60 * 1000},
    {Label: 'H', Scale: 60 * 60 * 1000}
];

